<template>
  <el-row type="flex" justify="center" class="center">
    <el-col
      :span="24"
      style="background:#fff;width:100%;height: 60px;
    border-bottom: 1px solid #eee;"
    >
      <div class="grid-content bg-purple-dark">
        <div style="float:left;line-height: 60px;height:60px;outline: none;">
          <p style="width: 100px;position: relative;display: inline-block;">
            <span class="log"></span>
          </p>
          <p style=" display: inline-block;color:#999">SFC Order Fulfillment</p>
        </div>
      </div>
    </el-col>

    <div class="center1">
      <div style="left:0">
        <p
          style=" padding: 20px 0;color:#333;font-size:16px;font-weight: normal;"
        >You need to associate an SFC account</p>
        <el-form ref="loginForm" :model="longinuser" :rules="longrules" @submit.native.prevent>
          <el-form-item prop="name">
            <el-input v-model="longinuser.name" placeholder="ID / E-mail"></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input v-model="longinuser.pass" type="password" maxlength="20" placeholder="Password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              v-bind:class="[disabled ? 'buttoncla' : 'buttoms']"
              @click="login"
              :disabled="disabled"
            >Confirm</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="line-height: 400px;">
        No account ?
        <router-link to="/Register">
          <a style="color: #8989ba;cursor: pointer;text-decoration: underline;">Register now</a>
        </router-link>
      </div>
    </div>
  </el-row>
</template>

<script>
import { UrlSearch } from '../../utils/UrlSearch'
import { loginfromshopify, getcountry } from '../api/user'
import { setToken, removeToken } from '../../utils/auth'
import store from '@/store'
var userparam = UrlSearch()
console.log(userparam.shop)
if (userparam.shop) {
  console.log(userparam.shop)
  var url = userparam.shop
  var index = url.indexOf('.')
  var shop = url.substring(0, index)
}
export default {
  mounted () {
    if (userparam.shop == undefined) {
      // removeToken()
      store.dispatch('setUser', null)
      // this.$router.push({ path: "/404" });
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          let param = {
            customer_id: this.longinuser.name, // 用户ID
            password: this.longinuser.pass, // 密码
            shop: shop // shopify店铺
          }

          loginfromshopify(param)
            .then(response => {
              if (response.data.ask == 1) {
                var username = response.data.userData
                // setToken("user", username); 这里
                store.dispatch('setUser', username)
                store.dispatch('updateusername', username.customer_id)
                this.$router.push({ path: '/home' })
              } else {
                // removeToken()
                store.dispatch('setUser', null)
                // this.$router.push({ path: "/" });
              }
              console.log(response)
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          return false
        }
      })
    }
  },

  data () {
    var name = (rule, value, callback) => {
      this.userID = true
      if (!value) {
        this.userID = false
        this.disabled = true
        return
      } else {
        let ragemal = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        let ragid = /^[A-Z][\d]{4}$/
        if (!ragemal.test(value) && !ragid.test(value)) {
          this.userID = false
          callback(new Error('please enter a number'))
        } else {
          callback()
        }
      }
      console.log(this.checkPass)
      console.log(this.userID)
      if (this.checkPass && this.userID) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
    const checkPw = (rule, value, callback) => {
      const reg = /^[^\u4e00-\u9fa5]{1,}$/
      this.checkPass = true
      if (!value) {
        this.disabled = true
        this.checkPass = false
        return
      }
      console.log(this.checkPass)
      console.log(this.userID)
      if (this.checkPass && this.userID) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      callback()
    }
    return {
      show: true, // 初始启用按钮
      count: '', // 初始化次数
      timer: null,
      disabled: true,
      checkPass: false,
      userID: false,
      longinuser: {},
      longrules: {
        name: [{ required: true, validator: name, trigger: 'blur' }],
        pass: [{ required: true, validator: checkPw, trigger: 'blur' }]
      }
    }
  }
}
</script>
<style scoped>
.center {
  position: absolute;
  background: #fbf8f8;
  width: 100%;
  height: 100%;
  min-width: 950px;
  top: 0;
}
.center1 {
  position: absolute;
  width: 680px;
  height: 420px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 20px;
}
.center1 > div {
  width: 300px;
  display: inline-block;
  padding: 30px;
  background: #ffff;
  height: 400px;
  border-radius: 5px;
  position: absolute;
}
.buttoncla {
  width: 100%;
  background: #ebebeb;
  color: #8a8a8a;
  outline: none;
  border: none;
}
.buttoncla:hover {
  width: 100%;
  background: #ebebeb;
  color: #8a8a8a;
  outline: none;
}
.buttoms {
  width: 100%;
  background: #8989ba;
  color: #fff;
  outline: none;
}
.center1 > div > form {
  height: 100%;
}
.el-icon-loading {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/login.vue